<script setup>
const props = defineProps({
  profile: Object,
  isActive: Boolean,
})

const { t } = useI18n()

const isConsumer = computed(() => props.profile.type === 'customer')
</script>

<template>
  <component
    :is="isActive ? 'div' : 'a'"
    class="my-2px flex flex-nowrap items-center gap-2 rounded px-4 py-2 text-sm text-secondary-300 hover:no-underline !active:bg-secondary !active:text-text-100"
    :class="{
      '!text-text-100 !bg-secondary': isActive,
      'hover:bg-secondary-100': !isActive,
    }"
    :href="`/switch_profile/${profile.id}`"
    :role="isActive ? '' : 'link'"
  >
    <div class="flex-shrink-0 p-2px text-20px">
      <i
        v-if="isConsumer"
        class="i-fas-user"
      />
      <i
        v-else
        class="i-fas-suitcase"
      />
    </div>
    <div class="flex-col truncate">
      <div class="truncate">
        {{ profile.name }}
      </div>
      <div
        v-if="isConsumer"
        class="truncate text-xs text-text-300"
      >
        {{ t('Consumer Account') }}
      </div>
      <div
        v-else
        class="truncate text-xs text-text-300"
      >
        {{ t('Business Account') }}
      </div>
    </div>
  </component>
</template>

<i18n>
{
  "en-us": {
    "Consumer Account": "Consumer Account",
    "Business Account": "Business Account"
  }
}
</i18n>

<i18n locale="de" lang="json">
{
  "Consumer Account": "Verbraucherkonto",
  "Business Account": "Unternehmenskonto"
}
</i18n>

<i18n locale="fr" lang="json">
{
  "Consumer Account": "Compte Client-e",
  "Business Account": "Compte d'affaires"
}
</i18n>

<i18n locale="es" lang="json">
{
  "Consumer Account": "Cuenta de cliente",
  "Business Account": "Cuenta de empresa"
}
</i18n>
